var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreativeCanvas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "creative-canvas-station-icon-layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 259.26 259.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .creative-canvas-station-icon-class-1 {\n        fill: #14163d;\n      }\n\n      .creative-canvas-station-icon-class-2 {\n        fill: #5bd8a3;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "creative-canvas-station-icon-layer-1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "creative-canvas-station-icon-class-1",
    cx: 129.63,
    cy: 129.63,
    r: 129.63
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "creative-canvas-station-icon-class-2",
    d: "m61.36,123.46h22.71c11.23,0,20.34,9.11,20.34,20.34v32.24h-63.39v-32.24c0-11.23,9.11-20.34,20.34-20.34Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "creative-canvas-station-icon-class-2",
    cx: 72.72,
    cy: 94.11,
    r: 21.91
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "creative-canvas-station-icon-class-2",
    d: "m175.19,123.46h22.71c11.23,0,20.34,9.11,20.34,20.34v32.24h-63.39v-32.24c0-11.23,9.11-20.34,20.34-20.34Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "creative-canvas-station-icon-class-2",
    cx: 186.54,
    cy: 94.11,
    r: 21.91
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "creative-canvas-station-icon-class-2",
    d: "m90.99,191.23v-41.02c0-13.51,10.99-24.51,24.51-24.51h28.26c13.51,0,24.51,10.99,24.51,24.51v41.02h-77.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "creative-canvas-station-icon-class-1",
    d: "m143.76,129.87c11.23,0,20.34,9.11,20.34,20.34v36.85h-68.94v-36.85c0-11.23,9.11-20.34,20.34-20.34h28.26m0-8.33h-28.26c-15.81,0-28.67,12.86-28.67,28.67v45.18h85.61v-45.18c0-15.81-12.86-28.67-28.67-28.67h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "creative-canvas-station-icon-class-2",
    d: "m129.63,125.94c-15.44,0-28-12.56-28-28s12.56-28,28-28,28,12.56,28,28-12.56,28-28,28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "creative-canvas-station-icon-class-1",
    d: "m129.63,74.12c13.16,0,23.83,10.67,23.83,23.83s-10.67,23.83-23.83,23.83-23.83-10.67-23.83-23.83,10.67-23.83,23.83-23.83m0-8.33c-17.73,0-32.16,14.43-32.16,32.16s14.43,32.16,32.16,32.16,32.16-14.43,32.16-32.16-14.43-32.16-32.16-32.16h0Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreativeCanvas);
export default __webpack_public_path__ + "static/media/CreativeCanvas.ddfa983f4eaca310a1dccd8e8bfa6487.svg";
export { ForwardRef as ReactComponent };